import React from 'react';
import { block } from 'bem-cn';
import Slider from 'react-slick';

import Typography from 'components/Typography';
import MediumButton from 'components/Buttons/MediumButton';

import './promo-plate.scss';

const b = block('promotion-plate');

type PromoPlatePropsType = {
  promoData: {
    promoName: string;
    image: string;
    deepLink: string;
    mainTexts: string[];
    header: string;
    description: string;
    button: string;
  };
  onClick: () => void;
  onClose: () => void;
};

const PromoPlate = ({ promoData, onClick, onClose }: PromoPlatePropsType) => {
  return (
    <div className={b()} onClick={onClick}>
      <div className={b('image-section')}>
        <Slider
          className={b('promo-title-slider')}
          dots={false}
          arrows={false}
          fade
          infinite
          autoplay
          speed={1000}
        >
          {promoData.mainTexts.map((text) => (
            <Typography
              key={text}
              className={b('promo-title').toString()}
              component='div'
              variant={Typography.THEME.VARIANTS.CARD_TITLE_BIG}
            >
              {text}
            </Typography>
          ))}
        </Slider>
        <div className={b('image-shade')} />
        <div className={b('close-button')} onClick={onClose} />
      </div>
      <div className={b('header-section')}>
        <div className={b('header-texts')}>
          <Typography
            className={b('header-title').toString()}
            component='div'
            variant={Typography.THEME.VARIANTS.CARD_TITLE_NORMAL}
          >
            {promoData.header}
          </Typography>
          <Typography
            className={b('header-description').toString()}
            component='div'
            variant={Typography.THEME.VARIANTS.TEXT_SMALL}
          >
            {promoData.description}
          </Typography>
        </div>
        <div className={b('header-buttons')}>
          <MediumButton
            title={promoData.button.toUpperCase()}
            variant={MediumButton.Variants.PRIMARY}
            onClick={() => {}}
          />
        </div>
      </div>
    </div>
  );
};

export default PromoPlate;
